import Choices from "choices.js";
import axios from "@main/axios";
import comissionCard from "@partials/comissionCard.handlebars";
import {logger} from "@main/helpers/logger";

const ZOOM_MAP_DEFAULT = 10;
const ZOOM_MAP_DEFAULT_ON_DESC = 16;
const ZOOM_MAP_CLICKING_ON_DOT = 18;
const RESTRICT_MAP_AREA = [[79.27135, -32.51953], [26.59522, -142.91016]];
const ZOOM_DURATION = 200;
const SHIFT_DEFAULT_POINT_ON_MAP = 0.0025;

class Map {
    map;
    mapData = [];
    url = null;
    lg = null;
    lt = null;
    placemarks = [];
    IDs = [];
    placeholderSelect = window.loc("MAP_PLACEHOLDER", {}, "Найти приемную комиссию");
    defaultOptionPlacemark = {
        iconLayout: "default#image",
        iconImageHref: "/assets/images/svg/icon-marker.svg",
        iconImageSize: [20, 20],
        iconImageOffset: [-10, -10],
    };
    select;

    geoObjects;

    inputsSearch = []

    /**
     * Всплывающий блок с информацией о выбранном на карте маркере
     *
     * @type {Element | null}
     */
    admissionsOfficeCard = document.querySelector(".map__balloon");

    constructor(mapNode) {
        this.map = mapNode;
        this.url = this.map.dataset.url;
        this.lg = mapNode.getAttribute("data-lg");
        this.lt = mapNode.getAttribute("data-lt");
        this.default = mapNode.getAttribute("data-default") || false;
        this.zoom = mapNode.getAttribute("data-zoom") || ZOOM_MAP_DEFAULT;
        this.mapTabsSlider = mapNode.previousElementSibling.querySelector(".js-tabs-map-slider");
        this.tabs = this.mapTabsSlider?.closest(".tabs");
        this.selects = this.tabs?.querySelectorAll(".js-select-choices");

        this.bindEventListeners();
    }

    // Выбор пункта из списка комиссий
    choiceComissionFromList(target) {
        const option = target.querySelector("option");

        const place = this.findPlaceByName(option.attributes.value.value);

        if (!place) {
            return;
        }

        this.placemarks[place.ID].events.fire("click", {
            coordPosition: this.placemarks[place.ID].geometry.getCoordinates(),
            target: this.placemarks[place.ID]
        });

        const chosenCommission = target.nextElementSibling.querySelector(".choices__item--selectable")
        chosenCommission.setAttribute("data-value", place.NAME);
        chosenCommission.innerHTML = place.NAME;
    }

    bindEventListeners() {
        this.mapTabsSlider?.addEventListener("click", this.onTabClick);
        document.addEventListener("click", this.onBalloonCloseClick)
        document.addEventListener("maponload", this.onMapLoaded);

        this.selects?.forEach(select => {
            select.addEventListener("change", (e) => {
                this.choiceComissionFromList(e.target);
            })
        });
    }

    /**
     * @param {string} name
     */
    findPlaceByName(name) {
        return this.mapData.data.commissionsData.find(place => place.NAME === name);
    }

    /**
     * Обработчик клика по вкладке на карте. Удаляет старые метки на карте и добавляет новые
     *
     * @param {Element} e
     */
    onTabClick = (e) => {
        if (!e.target.classList.contains("js-tabs-item")) {
            return;
        }

        e.preventDefault();

        this.clearMap();

        this.createSectionGeoObjects(this.getActiveSection());

        // Устанавливаем масштаб и центр карты
        const zoomMap = parseFloat(e.target.dataset.mapZoom);
        const centerMapLg = parseFloat(e.target.dataset.centerMapLg);
        const centerMapLt = parseFloat(e.target.dataset.centerMapLt);

        this.map.setCenter([centerMapLg, centerMapLt], zoomMap, {
            duration: ZOOM_DURATION,
        });

        this.admissionsOfficeCard.style.display = "none";
        this.admissionsOfficeCard.innerHTML = "";

        this.selects?.forEach(select => {
            const choicesList = select.nextElementSibling;
            const chosenCommission = choicesList.querySelector(".choices__item--selectable");
            chosenCommission.setAttribute("data-value", this.placeholderSelect);
            chosenCommission.innerHTML = this.placeholderSelect;
        });
    }

    /**
     * Закрытие карточки приемной комиссии
     *
     * @param {HTMLElement} e
     */
    onBalloonCloseClick = (e) => {
        if (!e.target.classList.contains("js-balloon-close")) {
            return;
        }

        this.admissionsOfficeCard.style.display = "none";
        this.admissionsOfficeCard.innerHTML = "";

        const selects = this.tabs.querySelectorAll(".choices__list--single");

        selects.forEach(select => {
            const chosenCommission = select.querySelector(".choices__item--selectable")
            chosenCommission.setAttribute("data-value", this.placeholderSelect);
            chosenCommission.innerHTML = this.placeholderSelect;
        });

        // Меняем масштаб и центр карты в зависимости от открытой вкладки
        const tabs = this.mapTabsSlider?.querySelectorAll(".js-tabs-item");

        tabs.forEach(tab => {
            if (tab.classList.contains("tabs__item--active")) {
                const zoomMap = parseFloat(tab.dataset.mapZoom);
                const centerMapLg = parseFloat(tab.dataset.centerMapLg);
                const centerMapLt = parseFloat(tab.dataset.centerMapLt);

                this.map.setCenter([centerMapLg, centerMapLt], zoomMap, {
                    duration: ZOOM_DURATION,
                });
            }
        })
    }

    /**
     * Первичная инициализация карты
     *
     * @returns {Promise<void>}
     */
    onMapLoaded = async () => {
        if (!this.default) {
            this.mapData = await this.getMapData();

            this.createInfoAdmissionsOffice((this.getActiveSection()));
            this.createSelectWithCommissions();

            this.inputsSearch = document.querySelectorAll(".choices__input[type='search']");
            this.trackSearchInput(this.inputsSearch);

            await this.createMap();

            // Замена иконки у точки при изменении масштаба карты
            this.map.events.add("boundschange", () => {
                const valueDisplayadmissionsOfficeCard = window.getComputedStyle(this.admissionsOfficeCard, null)
                    .getPropertyValue("display");

                if (valueDisplayadmissionsOfficeCard === "none") {
                    for (const placemark of Object.values(this.placemarks)) {
                        placemark.options.set({
                            iconLayout: this.defaultOptionPlacemark.iconLayout,
                            iconImageHref: placemark.options.get("iconImageHref"),
                            iconImageSize: this.defaultOptionPlacemark.iconImageSize,
                            iconImageOffset: this.defaultOptionPlacemark.iconImageOffset,
                        });
                    }
                }
            }, this);

            this.createSectionGeoObjects(this.getActiveSection());
        } else {
            const map = new ymaps.Map(this.map.getAttribute("id"), {
                center: [this.lg, this.lt],
                zoom: this.zoom,
                controls: [],
            }, {
                minZoom: 4,
                restrictMapArea: RESTRICT_MAP_AREA,
            });

            // Подключение кнопок масштабирования карты
            const zoomControl = new ymaps.control.ZoomControl({
                options: {
                    size: "small",
                    position: {
                        top: 250,
                        right: 16,
                        left: "auto",
                    }
                }
            });
            map.controls.add(zoomControl);

            this.map = map;
            this.setDefaultPlace();
            
        }
    }

    /**
     * @param {string} activeSection
     */
    createSectionGeoObjects(activeSection) {
        const sectionPlaces = this.mapData.data.commissionsData.filter(
            ({SECTION}) => SECTION === activeSection
        )

        this.geoObjects = new ymaps.GeoObjectCollection();

        sectionPlaces.forEach((place, index) => {
            const coord = place.COORDS.split(",");
            let icon = "/assets/images/svg/icon-marker.svg";

            this.IDs[index] = place.ID;

            if (place.CLOSE === true) {
                icon = "/assets/images/svg/icon-marker_close.svg";
            }
            
            this.placemarks[place.ID] = new ymaps.Placemark(
                [coord[0], coord[1]], {}, {
                    iconLayout: this.defaultOptionPlacemark.iconLayout,
                    iconImageHref: icon,
                    iconImageSize: this.defaultOptionPlacemark.iconImageSize,
                    iconImageOffset: this.defaultOptionPlacemark.iconImageOffset,
                }
            );
  
            let zoomCoordLgForMobile;
            let zoomCoordLtForDesktop;

            this.geoObjects.add(this.placemarks[place.ID]);
            this.map.geoObjects?.add(this.geoObjects);

            // Клик по точке на карте
            this.placemarks[place.ID].events
                .add("click", e => {
                    e.get("target").options.set({
                        iconLayout: "default#image",
                        iconImageHref: "/assets/images/svg/pin.svg",
                        iconImageSize: [64, 72],
                        iconImageOffset: [-32, -36],
                    });
                    this.admissionsOfficeCard.style.display = "block";
                    this.admissionsOfficeCard.innerHTML = comissionCard({
                        comission: {
                            name: place.NAME,
                            titleAddress: window.loc("MAP_ADDRESS", {}, "Полный адрес"),
                            address: place.ADDRESS,
                            metro: place.METRO,
                            titlePhone: window.loc("MAP_PHONE", {}, "Номер телефона"),
                            phone: place.PHONE,
                            titleSite: window.loc("MAP_SITE", {}, "Ссылка на сайт"),
                            site: place.SITE,
                            siteLink: place.SITELINK,
                            titleOpening: window.loc("MAP_TIME", {}, "Часы работы"),
                            opening: place.OPENING,
                        },
                    });

                    const open = this.admissionsOfficeCard.querySelector(".js-map-text-opening");
                    if (open) {
                        open.innerHTML = place.OPENING; 
                    }

                    if (window.innerWidth < 768) {
                        // сдвиг точки на карте по вертикали выше центра
                        zoomCoordLgForMobile = String(parseFloat(coord[0]) - SHIFT_DEFAULT_POINT_ON_MAP);

                        this.map.setCenter([zoomCoordLgForMobile, coord[1]], ZOOM_MAP_DEFAULT_ON_DESC, {
                            duration: ZOOM_DURATION,
                        });
                    } else {
                        //  сдвиг точки на карте по горизонтали правее центра
                        zoomCoordLtForDesktop = String(parseFloat(coord[1]) - 0.0005);

                        this.map.setCenter([coord[0], zoomCoordLtForDesktop], ZOOM_MAP_CLICKING_ON_DOT, {
                            duration: ZOOM_DURATION,
                        });
                    }

                    const selects = this.tabs.querySelectorAll(".choices__list--single");

                    selects.forEach(select => {
                        const chosenCommission = select.querySelector(".choices__item--selectable");

                        chosenCommission.setAttribute("data-value", place.NAME);
                        chosenCommission.innerHTML = place.NAME;
                    });
                });
        });
    }

    setDefaultPlace() {
        let zoomCoordLgForMobile;
        let zoomCoordLtForDesktop;
        const coord = [this.lg, this.lt];

        this.placemarks = [];
        this.placemarks[0] = new ymaps.Placemark(
            coord, null, {
                iconLayout: "default#image",
                iconImageHref: "/assets/images/svg/pin.svg",
                iconImageSize: [64, 72],
                iconImageOffset: [-32, -36],
            }
        );

        this.geoObjects = new ymaps.GeoObjectCollection();
        this.geoObjects.add(this.placemarks[0]);
        this.map.geoObjects?.add(this.geoObjects);

        if (window.innerWidth < 768) {
            // сдвиг точки на карте по вертикали выше центра
            zoomCoordLgForMobile = String(parseFloat(coord[0]) - SHIFT_DEFAULT_POINT_ON_MAP);

            this.map.setCenter([zoomCoordLgForMobile, coord[1]], ZOOM_MAP_DEFAULT_ON_DESC, {
                duration: ZOOM_DURATION,
            });
        } else {
            //  сдвиг точки на карте по горизонтали правее центра
            zoomCoordLtForDesktop = String(parseFloat(coord[1]) - SHIFT_DEFAULT_POINT_ON_MAP);

            this.map.setCenter([coord[0], zoomCoordLtForDesktop], ZOOM_MAP_DEFAULT_ON_DESC, {
                duration: ZOOM_DURATION ,
            });
        }
    }

    /**
     * Полностью очищает карту от всех маркеров
     */
    clearMap() {
        this.map.geoObjects?.remove(this.geoObjects);
        delete this.geoObjects;

        this.placemarks = {};
        this.IDs = {};
    }

    /**
     * @returns {Promise<*>}
     */
    async getMapData() {
        try {
            const {data} = await axios({
                url: this.url,
                method: "GET"
            });

            return data;
        } catch (e) {
            logger.log(e);
        }
    }

    /**
     * @returns {Element} Активная вкладка карты
     */
    getActiveTab() {
        return document.querySelector(".js-tabs-map-slider .tabs__item--active");
    }

    /**
     * @returns {string} ID активного раздела ИБ
     */
    getActiveSection() {
        const {dataset: {section}} = this.getActiveTab();

        return section;
    }

    /**
     * @returns {Promise<unknown>}
     */
    async createMap() {
        return new Promise((resolve) => {
            ymaps.ready(() => {
                const map = new ymaps.Map(this.map.getAttribute("id"), {
                    center: [this.lg, this.lt],
                    zoom: this.zoom,
                    controls: [],
                }, {
                    minZoom: 4,
                    restrictMapArea: RESTRICT_MAP_AREA,
                });

                // Подключение кнопок масштабирования карты
                const zoomControl = new ymaps.control.ZoomControl({
                    options: {
                        size: "small",
                        position: {
                            top: 250,
                            right: 16,
                            left: "auto",
                        }
                    }
                });
                map.controls.add(zoomControl);

                this.map = map;

                resolve({
                    map: this.map,
                    objects: this.geoObjects,
                })
            });
        })
    }

    createInfoAdmissionsOffice(activeSection) {
        const infoAdmissionsOffice = [];

        this.mapData.data.commissionsData.forEach(item => {
            if (activeSection !== item.SECTION) {
                return;
            }

            const [coordLg, coordLt] = item.COORDS.split(",");
            const selectItem = {
                value: item.NAME,
                customProperties: {
                    valueId: item.ID,
                    coordLg: coordLg,
                    coordLt: coordLt,
                    address: item.ADDRESS,
                    metro: item.METRO,
                },
            }

            infoAdmissionsOffice.push(selectItem);
        })

        return infoAdmissionsOffice;
    }

    createSelectWithCommissions() {
        this.selects?.forEach(select => {
            const tabSection = select.getAttribute("data-tab-section");

            this.select = new Choices(select, {
                choices: this.createInfoAdmissionsOffice(tabSection),
                searchChoices: true,
                fuseOptions: {
                    threshold: 1,
                },
                searchFields: ["value", "customProperties.address", "customProperties.metro"],
                position: "bottom",
                shouldSort: false,
                itemSelectText: "",
                searchPlaceholderValue: window.loc("MAP_PLACEHOLDER", {}, "Найти приемную комиссию"),
                noResultsText: window.loc("MAP_NO_RESULTS_TEXT", {}, "Не найдено"),
            });

            this.select.passedElement.element.addEventListener("choice", (e) => {
                this.choiceComissionFromList(e.target);
            })
        })
    }

    /**
     * Отслеживаем наличие значения в строке поиска.
     * Если открыт балун с информацией о центре и поле поиска не пустое, то балун скрывается
     * 
     * @param {HTMLInputElement} inputs 
     * @returns {void}
     */
    trackSearchInput(inputs) {         
        const balloon = document.querySelector(".map__balloon");

        inputs.forEach(input => {
            input.addEventListener("input", (e) => {
                if (e.target.value !== "" && getComputedStyle(balloon).display == "block") {
                    balloon.style.display = "none";
                } 
            })
        })
    } 
}

document.addEventListener("DOMContentLoaded", () => {
    const map = document.querySelector(".js-map");
    if (map) {
        new Map(map);
    }
});
